import { useContext } from "react";
import { ApplicationContext } from 'context'
import dayjs from 'dayjs'

import LayoutContainer from "components/LayoutContainer"

import styles from './styles.module.scss'

const Settings = () => {
  const { contextAgency, contextError, contextLoading } = useContext(ApplicationContext)
  const [isLoading, setIsLoading] = contextLoading  // eslint-disable-line
  const [error, setError] = contextError // eslint-disable-line
  const [agency] = contextAgency

  return(
    <LayoutContainer title="Settings" description="Below are a list of basic settings for your Agency.">
      <div className={styles.settingsContainer}>
        <div className={styles.settingsSetction}>
          <div className={styles.settingsSetction_left}>
            <h3>General Settings</h3>
            <p>Joined {dayjs(agency.createdAt).format('MMMM D YYYY')}</p>
          </div>
          <div className={styles.settingsSetction_right}>
            &nbsp;
          </div>    
        </div>
      </div>
    </LayoutContainer>
  )
}

export default Settings